import './App.css';
import ExercisesList from './components/exercisesList/exercisesList';
import SignIn from './components/signIn/signIn';
import { AnimatePresence,LayoutGroup,motion } from 'motion/react';
import { Toaster } from 'react-hot-toast';
import { Activity, Briefcase, CheckCircle, Coffee, Compass, Facebook, Globe, Info, Instagram, Loader, Music, Settings, Youtube, Zap } from 'react-feather';
import { useEffect, useState } from 'react';
import User from './components/user/user';
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import ConfettiExplosion from 'react-confetti-explosion';
import { getDatabase, onValue, ref } from 'firebase/database';
import moment from 'moment';
import Chat from './components/chat/chat';
import ReactGA from 'react-ga4' ; ReactGA.initialize('G-4EVYDGMB49') ;
function App() {
  const [confetti,setConfetti] = useState(false);
  const [hasPracticedToday,setHasPracticedToday] = useState('loading');
  const [isLoading,setIsLoading]=useState(true);
  const [auth,setAuth]=useState(false);
  const [user,setUser] = useState(false);
  const [app,setApp] = useState(false);
    const [streak,setStreak]=useState('loading');
    const [oldStreak,setOldStreak]=useState('loading');
    useEffect(()=>{
      ReactGA.send({ hitType : "pageview", page : window.location.pathname }) ;
      if(oldStreak == 'loading'){
        return;
      }
      if(streak > oldStreak){
        setConfetti(true);
        setTimeout(()=>setConfetti(false),3000);
        Toaster.success('One more day !')
      }
      if(streak != 'loading')
        setOldStreak(streak)
    },[streak])
  useEffect(()=>{
    if(!app){
const firebaseConfig = {
apiKey: "AIzaSyC7BDiPkRebm-EJ8kRhVjiXxivQY813qhk",
  authDomain: "ifetz-91f4e.firebaseapp.com",
  projectId: "ifetz-91f4e",
  storageBucket: "ifetz-91f4e.firebasestorage.app",
  messagingSenderId: "883021950323",
  appId: "1:883021950323:web:4fa87aaa9074f2f9c6a906",
  measurementId: "G-4EVYDGMB49",
  databaseURL: "https://ifetz-91f4e-default-rtdb.firebaseio.com"
};
setApp(initializeApp(firebaseConfig));

    } 



  },[])
  useEffect(()=>{
    if(isLoading)
      return;
    if(!user){
      setStreak(0)
      return;
    }
    if(user && app){
      const starCountRef = ref(getDatabase(app), 'users/' + user.uid);
onValue(starCountRef, (snapshot) => {
  
  if(!snapshot.exists()){
    setStreak(0);
    if(oldStreak == 'loading')
      setOldStreak(0)
    return;
  }
  const data = snapshot.val();
  const l = new Date(data.lastActivity);
  setHasPracticedToday(new Date().toDateString() === l.toDateString());
  if(new Date().getTime() - data.lastActivity >= 60*60*24*2*1000){
    setStreak(0);
    if(oldStreak == 'loading')
      setOldStreak(0)
  } else{
    const s = moment(new Date(data.lastActivity).toISOString().split('T')[0]).diff(moment(new Date(data.streakBegin).toISOString().split('T')[0]),'days') //Math.floor((data.lastActivity - data.streakBegin) / (60*60*24*1000))+1;
    setStreak(s+1);
    if(oldStreak == 'loading')
      setOldStreak(s+1)
  }
});
    }
  },[user,app,isLoading])


  useEffect(()=>{
  if(app){
setAuth(getAuth(app));
  }
},[app])
  useEffect(()=>{
    if(auth){
      
auth.onAuthStateChanged((user) => {
  setIsLoading(false);
  if (user) {
    setUser(user);
  } else {
    setUser(false);
  }
});
    }
  },[auth])
const [isOpen,setIsOpen] = useState();
  return (
    <>
    <div><Toaster position="bottom-center"/></div>
    <div className='confetti'>
      {confetti?<ConfettiExplosion force={0.8} duration={3000} particleCount={250}/>:<></>}
    </div>
<div className='bg'></div>
    <div className='container'>
      <div className='header'>
      <h1>iFetz
        <small>An idea of <a href="https://emmanuelcoppey.com" target='_blank'><strong>Emmanuel Coppey</strong> <Info/></a></small>
        <ul>
          <li><a href="https://instagram.com/emmanuelcoppey" target='_blank'><Instagram/></a></li>
          <li><a href="https://www.facebook.com/emmanuelcp" target='_blank'><Facebook/></a></li>
          <li><a href="https://www.youtube.com/@emmanuelcoppey" target='_blank'><Youtube/></a></li>
          <li><a href="https://emmanuelcoppey.com" target='_blank'><Globe/></a></li>
        </ul>
      </h1>
      <div className='currentUser'>
      <LayoutGroup>
             {
            isOpen?<div className='overlay' onClick={()=>setIsOpen(false)}></div>:<></>}
          <motion.div
          transition={{type:'spring',bounce:.25,duration:.5}}
          style={isOpen?{
            position:'fixed',
            bottom:20,
            left:20,
            right:20,
            background:'#fff',
            border:0,
            height:'auto',
        zIndex:10,
        borderRadius:20
          }:{

        borderRadius:20
          }}
          layout  drag={isOpen?'y':''}
  dragConstraints={{ top: 0,bottom:0 }}
dragElastic={{top:0,bottom:.4}}
onDragEnd={(e,i)=>{
  if(i.offset.y > 50){
    setIsOpen(false)
  }
}} className={isOpen?'button isOpen':'button'} onClick={()=>{
  if(isLoading)
    return;
            if(!isOpen)
            setIsOpen(true)
          }}>
            {isLoading?<><Loader className='loading'/></>:isOpen?
            user?
            <User auth={auth}/>:<SignIn app={app} setConfetti={setConfetti} setIsOpen={setIsOpen} setUser={setUser} auth={auth}/>:
            user?
            <Settings/>:'Sign in/up'}
          </motion.div>
          </LayoutGroup>
        </div>
      </div>
      
      <p>This app brings a new perspective on practicing scales. Inspired by <a href="https://www.youtube.com/watch?v=TFuZenl4qeI" target='_blank'>Paganini's secret <Youtube/></a>, it develops a transversal approach of the left hand, making one practice every tonality in every position, and creating a sense of pattern that makes the fingerboard feel unified accross registers. See <a href="https://www.youtube.com/watch?v=Sz7E4VH4tkk" target='_blank'>A shortcut to violin virtuosity <Youtube/></a> for more information.</p>
      <div className={streak=='loading'?'streaksLoading streaksContainer':'streaksContainer'}>
        <div className='streaks'>
        <div className='streaksNumber'>
          <div>
            <h4>{streak=='loading'?<Loader className='loading'/>:streak}</h4>
            <small><Zap/> Streak days</small>
          </div>
        </div>
        <div className='streaksSteps'>
          <ul>
            <li className={streak>0&&streak<8?'active':''}>
              <i><Coffee/></i>
             <small>Hobby</small>
            </li>
            <li className={streak>7&&streak<30?'active':''}>
              <i><Compass/></i>
             <small>Explorer</small>
            </li>
            <li className={streak>29&&streak<(30*6)?'active':''}>
              <i><Briefcase/></i>
             <small>Professional</small>
            </li>
            <li className={streak>(30*6-1)?'active':''}>
              <i><Music/></i>
             <small>Master</small>
            </li>
          </ul>
        </div>
        </div>
        <div className='streaksFooter'>
          <small>{streak=='loading'?'Loading...':streak==0?'Start practicing !':<>Days remaining : { streak>0&&streak<8?7-streak:
                streak>7&&streak<30?30-streak:
                  streak>29&&streak<(30*6)?(30*6)-streak:
                    streak>(30*6-1)?365-streak:0}</>}
                    <strong>{hasPracticedToday!='loading'?hasPracticedToday?<><CheckCircle/> You practiced today</>:<>You haven't practiced yet</>:''}</strong>
                    </small>
          <div className='streaksProgressContainer'>
            <motion.div layout className='streaksProgress' style={{
              width:(
              streak>0&&streak<8?streak/7:
                streak>7&&streak<30?streak/30:
                  streak>29&&streak<(30*6)?streak/(30*6):
                    streak>(30*6-1)?streak/365:0)*100+'%'}}></motion.div>
          </div>
        </div>
      </div>
      <ExercisesList app={app} loading={isLoading} user={user}/>
      <Chat auth={auth} app={app} user={user}/>
    </div>
    </>

  );
}

export default App;